function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }

function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

// @ts-nocheck
import React, { Component } from 'react';
import { orderProperties, retrieveSchema, getDefaultRegistry, getUiOptions, ADDITIONAL_PROPERTY_FLAG } from "../../utils";
import AddButton from "../AddButton";

function DefaultObjectFieldTemplate(props) {
  var _props$uiSchema$uiTi, _props$title;

  const canExpand = function canExpand() {
    const {
      formData,
      schema,
      uiSchema
    } = props;

    if (!schema.additionalProperties) {
      return false;
    }

    const {
      expandable
    } = getUiOptions(uiSchema);

    if (expandable === false) {
      return expandable;
    } // if ui:options.expandable was not explicitly set to false, we can add
    // another property if we have not exceeded maxProperties yet


    if (schema.maxProperties !== undefined) {
      return Object.keys(formData).length < schema.maxProperties;
    }

    return true;
  };

  const {
    TitleField,
    DescriptionField
  } = props;
  return /*#__PURE__*/React.createElement("fieldset", {
    id: props.idSchema.$id
  }, ((_props$uiSchema$uiTi = props.uiSchema['ui:title']) !== null && _props$uiSchema$uiTi !== void 0 ? _props$uiSchema$uiTi : props.title) && /*#__PURE__*/React.createElement(TitleField, {
    id: `${props.idSchema.$id}__title`,
    title: (_props$title = props.title) !== null && _props$title !== void 0 ? _props$title : props.uiSchema['ui:title'],
    required: props.required,
    formContext: props.formContext
  }), props.description && /*#__PURE__*/React.createElement(DescriptionField, {
    id: `${props.idSchema.$id}__description`,
    description: props.description,
    formContext: props.formContext
  }), props.properties.map(prop => prop.content), canExpand() && /*#__PURE__*/React.createElement(AddButton // className="object-property-expand"
  , {
    onClick: props.onAddClick(props.schema),
    disabled: props.disabled || props.readonly
  }));
}

class ObjectField extends Component {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "state", {
      wasPropertyKeyModified: false,
      additionalProperties: {}
    });

    _defineProperty(this, "onPropertyChange", (name, addedByAdditionalProperties = false) => (value, errorSchema) => {
      if (!value && addedByAdditionalProperties) {
        // Don't set value = undefined for fields added by
        // additionalProperties. Doing so removes them from the
        // formData, which causes them to completely disappear
        // (including the input field for the property name). Unlike
        // fields which are "mandated" by the schema, these fields can
        // be set to undefined by clicking a "delete field" button, so
        // set empty values to the empty string.
        value = '';
      }

      let newFormData = _objectSpread(_objectSpread({}, this.props.formData), {}, {
        [name]: value
      }); // @TODO: added


      if (!value && !addedByAdditionalProperties) {
        const {
          [name]: x
        } = newFormData,
              rest = _objectWithoutProperties(newFormData, [name].map(_toPropertyKey));

        newFormData = rest;
      } // @TODO: end


      this.props.onChange(newFormData, errorSchema && this.props.errorSchema && _objectSpread(_objectSpread({}, this.props.errorSchema), {}, {
        [name]: errorSchema
      }));
    });

    _defineProperty(this, "onDropPropertyClick", key => event => {
      event.preventDefault();
      const {
        onChange,
        formData
      } = this.props;

      const copiedFormData = _objectSpread({}, formData);

      delete copiedFormData[key];
      onChange(copiedFormData);
    });

    _defineProperty(this, "getAvailableKey", (preferredKey, formData) => {
      let index = 0;
      let newKey = preferredKey;

      while (formData.hasOwnProperty(newKey)) {
        newKey = `${preferredKey}-${++index}`;
      }

      return newKey;
    });

    _defineProperty(this, "onKeyChange", oldValue => (value, errorSchema) => {
      if (oldValue === value) {
        return;
      }

      value = this.getAvailableKey(value, this.props.formData);

      const newFormData = _objectSpread({}, this.props.formData);

      const newKeys = {
        [oldValue]: value
      };
      const keyValues = Object.keys(newFormData).map(key => {
        var _newKeys$key;

        const newKey = (_newKeys$key = newKeys[key]) !== null && _newKeys$key !== void 0 ? _newKeys$key : key;
        return {
          [newKey]: newFormData[key]
        };
      });
      const renamedObj = Object.assign({}, ...keyValues);
      this.setState({
        wasPropertyKeyModified: true
      });
      this.props.onChange(renamedObj, errorSchema && this.props.errorSchema && _objectSpread(_objectSpread({}, this.props.errorSchema), {}, {
        [value]: errorSchema
      }));
    });

    _defineProperty(this, "handleAddClick", schema => () => {
      let {
        type
      } = schema.additionalProperties;

      const newFormData = _objectSpread({}, this.props.formData);

      if (schema.additionalProperties.hasOwnProperty('$ref')) {
        const {
          registry = getDefaultRegistry()
        } = this.props;
        const refSchema = retrieveSchema({
          $ref: schema.additionalProperties.$ref
        }, registry.rootSchema, this.props.formData);
        type = refSchema.type;
      }

      newFormData[this.getAvailableKey('newKey', newFormData)] = this.getDefaultValue(type);
      this.props.onChange(newFormData);
    });
  }

  isRequired(name) {
    const {
      schema
    } = this.props;
    return Array.isArray(schema.required) && schema.required.indexOf(name) !== -1;
  }

  getDefaultValue(type) {
    switch (type) {
      case 'string':
        return 'New Value';

      case 'array':
        return [];

      case 'boolean':
        return false;

      case 'null':
        return null;

      case 'number':
        return 0;

      case 'object':
        return {};

      default:
        // We don't have a datatype for some reason (perhaps additionalProperties was true)
        return 'New Value';
    }
  }

  render() {
    var _uiSchema$uiDescript, _ref, _uiSchema$uiObjectFi, _uiSchema$uiTitle;

    const {
      uiSchema,
      formData,
      errorSchema,
      idSchema,
      name,
      required,
      disabled,
      readonly,
      idPrefix,
      onBlur,
      onFocus,
      registry = getDefaultRegistry()
    } = this.props;
    const {
      definitions,
      fields,
      rootSchema,
      formContext
    } = registry;
    const {
      SchemaField,
      TitleField,
      DescriptionField
    } = fields;
    const schema = retrieveSchema(this.props.schema, rootSchema, formData); // If this schema has a title defined, but the user has set a new key/label, retain their input.

    let title;

    if (this.state.wasPropertyKeyModified) {
      title = name;
    } else {
      title = schema.title === undefined ? name : schema.title;
    }

    const description = (_uiSchema$uiDescript = uiSchema['ui:description']) !== null && _uiSchema$uiDescript !== void 0 ? _uiSchema$uiDescript : schema.description;
    let orderedProperties;

    try {
      var _schema$properties;

      const properties = Object.keys((_schema$properties = schema.properties) !== null && _schema$properties !== void 0 ? _schema$properties : {});
      orderedProperties = orderProperties(properties, uiSchema['ui:order']);
    } catch (err) {
      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("p", {
        // className="config-error"
        style: {
          color: 'red'
        }
      }, "Invalid", ' ', name !== null && name !== void 0 ? name : 'root', ' ', "object field configuration:", /*#__PURE__*/React.createElement("em", null, err.message), "."), /*#__PURE__*/React.createElement("pre", null, JSON.stringify(schema)));
    }

    const Template = (_ref = (_uiSchema$uiObjectFi = uiSchema['ui:ObjectFieldTemplate']) !== null && _uiSchema$uiObjectFi !== void 0 ? _uiSchema$uiObjectFi : registry.ObjectFieldTemplate) !== null && _ref !== void 0 ? _ref : DefaultObjectFieldTemplate;
    const templateProps = {
      title: (_uiSchema$uiTitle = uiSchema['ui:title']) !== null && _uiSchema$uiTitle !== void 0 ? _uiSchema$uiTitle : title,
      description,
      TitleField,
      DescriptionField,
      properties: orderedProperties.map(name => {
        const addedByAdditionalProperties = schema.properties[name].hasOwnProperty(ADDITIONAL_PROPERTY_FLAG);
        return {
          content: /*#__PURE__*/React.createElement(SchemaField, {
            key: name,
            name: name,
            required: this.isRequired(name),
            schema: schema.properties[name],
            uiSchema: addedByAdditionalProperties ? uiSchema.additionalProperties : uiSchema[name],
            errorSchema: errorSchema[name],
            idSchema: {
              $id: `${idSchema.$id}_${name}`
            },
            idPrefix: idPrefix,
            formData: (formData !== null && formData !== void 0 ? formData : {})[name],
            wasPropertyKeyModified: this.state.wasPropertyKeyModified,
            onKeyChange: this.onKeyChange(name),
            onChange: this.onPropertyChange(name, addedByAdditionalProperties),
            onBlur: onBlur,
            onFocus: onFocus,
            registry: registry,
            disabled: disabled,
            readonly: readonly,
            onDropPropertyClick: this.onDropPropertyClick
          }),
          name,
          readonly,
          disabled,
          required
        };
      }),
      readonly,
      disabled,
      required,
      idSchema,
      uiSchema,
      schema,
      formData,
      formContext
    };
    return /*#__PURE__*/React.createElement(Template, _extends({}, templateProps, {
      onAddClick: this.handleAddClick
    }));
  }

}

_defineProperty(ObjectField, "defaultProps", {
  uiSchema: {},
  formData: {},
  errorSchema: {},
  idSchema: {},
  required: false,
  disabled: false,
  readonly: false
});

export default ObjectField;